<template>
  <v-app>
    <router-view />
    <v-overlay
      :value="$store.getters.isGlobalOverlayActive"
      z-index="900">
      <div class="text-center">
        <div
          id="global-loading-msg"
          class="mb-6">
          {{$store.state.loadingMessage}}
        </div>
        <v-progress-circular
          indeterminate
          size="64">
        </v-progress-circular>
      </div>
    </v-overlay>

    <!-- Warning Dialog -->
    <WarningDialog />
    <!-- / Warning Dialog -->

    <!-- Confirm Dialog -->
    <ConfirmDialog />
    <!-- / Confirm Dialog -->
  </v-app>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('initialize');
  },
};
</script>

<style lang="scss">
#global-loading-msg {
  font-size: 16px;
}
</style>
